import type { MetricsFrameworkTabId, PageConfig } from '../types';
import { overviewPageConfig } from './overview';
import { yourDealershipPageConfig } from './yourDealership';
import { revivalResultsPageConfig } from './revivalResults';
import { activityPageConfig } from './activity';
import { pipelinePageConfig } from './pipeline';
import { lookingAheadPageConfig } from './lookingAhead';

export const PAGE_CONFIGS: Record<MetricsFrameworkTabId, PageConfig> = {
  overview: overviewPageConfig,
  'your-dealership': yourDealershipPageConfig,
  'revival-results': revivalResultsPageConfig,
  activity: activityPageConfig,
  pipeline: pipelinePageConfig,
  'looking-ahead': lookingAheadPageConfig,
};

export const getPageConfig = (view: MetricsFrameworkTabId): PageConfig => PAGE_CONFIGS[view];
